import config from './config';
import { handleResponse } from './handle-response';
import { checkToken, authHeader } from './helpers'

export const horseService = {
    find,
    ancestry,
	retrieve,
	createNewHorse,
	getCountries,
	resolveSponsoredToken
}

async function find(params) {

    const query = new URLSearchParams(params).toString();

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    };

    return fetch(`${config.apiUrl}/horses/find/?${query}`, requestOptions)
        .then(handleResponse)
        .then(response => response);
}


async function ancestry(horse_id, horse_type) {
    let params = {
        horse_sire: horse_type === 'horse_sire',
        horse_dam: horse_type === 'horse_dam'
    }
    params = new URLSearchParams(params).toString()
    const requestOptions = { method: 'GET', params: params }
    
    return fetch(`${config.apiUrl}/horses/${horse_id}/ancestry/?${params}`, requestOptions)
        .then(handleResponse)
        .then(ancestry => {
            return ancestry
        })
}

async function retrieve(horseId) {
	const requestOptions = { method: 'GET' }
	return fetch(`${config.apiUrl}/horses/${horseId}/`, requestOptions)
		.then(handleResponse)
		.then(data => data)
}

async function createNewHorse(horseData) {
	await checkToken()
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(horseData)
	}
	return fetch(`${config.apiUrl}/horses/`, requestOptions)
		.then(handleResponse)
		.then(data => data)
}

async function getCountries() {
	const requestOptions = { method: 'GET' }
	return fetch(`${config.apiUrl}/horses/countries/`, requestOptions)
		.then(handleResponse)
		.then(data => data)
}

async function resolveSponsoredToken(token) {
	const requestOptions = { method: 'GET' }
	return fetch(`${config.apiUrl}/horses/sponsored-entry/resolve/?token=${encodeURIComponent(token)}`, requestOptions)
		.then(handleResponse)
		.then(data => data)
}
